import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AddonService } from 'src/app/private/services/addon.service';
import { ClientService } from 'src/app/private/services/client.service';
import { PackageService } from 'src/app/private/services/package.service';

@Component({
  selector: 'app-assign-addon',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './assign-addon.component.html',
  styleUrl: './assign-addon.component.scss'
})
export class AssignAddonComponent  implements OnChanges {

  @Input() visible: boolean = false;
  @Input() clientAddon: any = {};
  @Output() close = new EventEmitter<void>();
  @Output() reload = new EventEmitter<void>();
  formAction = "Create";

  assignForm!: FormGroup;
  isLoading = false;

  clients: any[] = [];
  addons: any[] = [];
  packageSubscriptions: any[] = [];
  selectedAddon: any = null;
  selectedClient: any = null;

  statusOptions = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Paused', value: 'Paused' },
    { label: 'Suspended', value: 'Suspended' },
    { label: 'Cancelled', value: 'Cancelled' }
  ];

  paymentStatus = [
    { label: 'Pending', value: 'Pending' },
    { label: 'Paid', value: 'Paid' },
    { label: 'Failed', value: 'Failed' },
    { label: 'Refunded', value: 'Refunded' },
    { label: 'Cancelled', value: 'Cancelled' }
  ];
  constructor(
    private fb: FormBuilder,
    private addonService: AddonService,
    private clientService: ClientService,
     private packageService: PackageService,
    private messageService: MessageService
  ) {
    
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['clientAddon'] && this.clientAddon && this.clientAddon.id) {
    // Input value is now available
    this.patchFormForEdit();
  }
  }

  ngOnInit() {
    
    //  if (this.visible) {
    //   alert()
    //   console.log(this.clientAddon)
    //   this.assignForm.patchValue({
    //     client_id: this.clientAddon.client_id,
    //     subscription_id: this.clientAddon.subscription_id,
    //     addon_id: this.clientAddon.addon_id,
    //     quantity: this.clientAddon.quantity,
    //     notes: this.clientAddon.notes,
    //   });
    // }
    this.initForm();
    this.loadClients();
    this.loadAddons();

    
  }
   patchFormForEdit() {
    if (!this.clientAddon || this.clientAddon.id === undefined) return;
    
    const data = this.clientAddon;
    console.log(this.clientAddon);
    
    this.assignForm.patchValue({
      client_id: data.subscription?.client_id,
      subscription_id: data.subscription_id,
      addon_id: data.addon_id,
      quantity: data.quantity ?? 1,
      status: data.status ?? 'Inactive',
      payment_status: data.payment_status ?? 'Pending',
      billing_type: 'Fixed', // Always fixed
      notes: data.notes ?? ''
    });

    this.selectedAddon = data.package_addon;
  }
  // --------------------------
  // INIT FORM
  // --------------------------
  initForm() {
    this.assignForm = this.fb.group({
      client_id: ['', Validators.required],
      subscription_id: ['', Validators.required],
      package_subscription_id: ['', Validators.required],
      addon_id: [null, Validators.required],
      quantity: [1, [Validators.required, Validators.min(1)]],
      status: ['Inactive', Validators.required],
      payment_status: ['Pending', Validators.required],
      
      // BILLING TYPE - FIXED BY DEFAULT (hidden in UI)
      billing_type: ['Fixed', Validators.required],
      
      notes: ['']
    });
  }


  // --------------------------
  // LOAD CLIENTS
  // --------------------------
  loadClients() {
    const payload = {
      page: 0,
      limit: 1000,
      where: {},
      order: { col: 'name', dir: 'ASC' }
    };

    this.clientService.getAllClients(payload).subscribe({
      next: (res: any) => {
        this.clients = (res.rows || []).map((client: any) => ({
          client_id: client.client_id,
          client_name: client.name,
          email: client.email,
          phone: client.phone
        }));
        console.log('All clients loaded:', this.clients);
      },
      error: (err) => {
        console.error('Error loading clients:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load clients'
        });
      }
    });
  }


  // --------------------------
  // LOAD ADD-ONS
  // --------------------------
  loadAddons() {
    const data = {
      page: 0,
      limit: 1000,
      where: { is_active: true },
      order: { col: 'name', dir: 'ASC' }
    };

    this.addonService.getAllPackageAddon(data).subscribe({
      next: (res: any) => {
        this.addons = (res.rows || []).map((a: any) => ({
          ...a,
          addon_name: a.addon_name || a.name // failsafe mapping
        }));
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load add-ons'
        });
      }
    });
  }

  // --------------------------
  // TOTAL PRICE
  // --------------------------
  getTotalPrice(): number {
    if (!this.selectedAddon) return 0;
    const qty = this.assignForm.get('quantity')?.value || 1;
    return (this.selectedAddon.price || 0) * qty;
  }

  // --------------------------
  // SUBMIT
  // --------------------------
  submitForm() {
    if (this.assignForm.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please fill all required fields'
      });
      return;
    }

    this.isLoading = true;
    const payload = this.assignForm.value;
    
    // Check if editing existing addon (has id) or creating new one
    if (this.clientAddon && this.clientAddon.id) {
      // UPDATE existing addon
      payload.id = this.clientAddon.id;
      this.addonService.updateAddonToClient(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Add-on updated successfully'
          });

          this.reload.emit();
          this.handleClose();
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error updating add-on:', error);

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update add-on'
          });
        }
      });
    } else {
      // CREATE new addon
      this.addonService.assignAddonToClient(payload).subscribe({
        next: () => {
          this.isLoading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Add-on assigned to client successfully'
          });

          this.reload.emit();
          this.handleClose();
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Error assigning add-on:', error);

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to assign add-on'
          });
        }
      });
    }
  }

  // --------------------------
  // CLOSE / RESET
  // --------------------------
  handleClose() {
    this.assignForm.reset();
    this.selectedAddon = null;
    this.close.emit();
  }

  // --------------------------
  // UTILITY (for formatting)
  // --------------------------
  formatKey(value: string) {
    return value?.replace(/_/g, ' ') ?? '';
  }
  // Add inside the component class
onAddonSelect(event: any) {
  // PrimeNG p-dropdown emits event.value as the selected optionValue
  const addonId = event?.value;

  // keep the form value in sync (optional — p-dropdown already sets it)
  this.assignForm.get('addon_id')?.setValue(addonId);

  // find and set the selected addon for preview
  this.selectedAddon = this.addons.find(a => a.id === addonId) || null;
}
onClientSelect(event: any) {
  const clientId = event?.value;
  
  if (!clientId) {
    this.packageSubscriptions = [];
    this.assignForm.get('package_subscription_id')?.setValue(null);
    this.assignForm.get('subscription_id')?.setValue(null);
    return;
  }

  // Load package subscriptions for this client
  this.loadClientPackageSubscriptions(clientId);
}

loadClientPackageSubscriptions(clientId: string) {
  const payload = {
    page: 0,
    limit: 100,
    where: { client_id: clientId, status: 'Active' },
    order: { col: '"package_subscription"."createdAt"', dir: 'DESC' }
  };

  this.packageService.getAllPackageSubscription(payload).subscribe({
    next: (res: any) => {
      this.packageSubscriptions = (res.rows || []).map((item: any) => ({
        subscription_id: item.subscription_id,
        package_subscription_id: item.id,
        package_name: item.package?.package_name || 'Unknown Package',
        billing_cycle: item.billing_cycle || 'N/A',
        status: item.status,
        price: item.package?.price || 0
      }));
      
      // Auto-select if only one subscription
      if (this.packageSubscriptions.length === 1) {
        this.assignForm.get('package_subscription_id')?.setValue(this.packageSubscriptions[0].package_subscription_id);
        this.assignForm.get('subscription_id')?.setValue(this.packageSubscriptions[0].subscription_id);
      }
    },
    error: (err) => {
      console.error('Error loading package subscriptions:', err);
      this.packageSubscriptions = [];
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load package subscriptions'
      });
    }
  });
}


getFormattedFeatures(featureObj: any): { label: string; value: any }[] {
  if (!featureObj || typeof featureObj !== 'object') return [];

  return Object.keys(featureObj).map(key => ({
    label: this.formatKey(key), // converts email_limit → email limit
    value: featureObj[key]
  }));
}
}
